import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import AuthShell, { Field } from "./AuthShell";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success("Welcome to GTForce! Your Worker ID is ready.");
      navigate("/app", { replace: true });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Join the Global Task Force" subtitle="Create your worker account in seconds."
      footer={<>Already have an account? <Link to="/login" className="text-[#1D4ED8] font-semibold">Sign in</Link></>}>
      <form onSubmit={submit} className="space-y-4">
        <Field label="Full name" data-testid="register-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Your name" />
        <Field label="Email" data-testid="register-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="you@company.com" />
        <Field label="Password" data-testid="register-password" type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="Choose a strong password" />
        <button data-testid="register-submit" disabled={loading} className="w-full py-3 rounded-full bg-[#1D4ED8] text-white font-semibold hover:bg-[#1E40AF] transition-colors disabled:opacity-60">
          {loading ? "Creating account…" : "Create Account"}
        </button>
      </form>
    </AuthShell>
  );
}
